import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modules/user'
import permission from './modules/permission'
import menu from './modules/menu'
import member from './modules/member'
import student from './modules/student'
import event from './modules/event'
import record from './modules/record'
import course from './modules/course'
import coach from './modules/coach'
import classhour from './modules/classhourspend'
import appointmenttype from './modules/appointmenttype'
import coursetype from './modules/coursetype'
import classtype from './modules/classtype'
import coursepackage from './modules/coursepackage'
import studentandclasstype from './modules/studentAndClassType'
import school from './modules/school'
import teachingpoint from './modules/teachingpoint'
import show from './modules/show'
import locationAndClasstype from './modules/locationAndClasstypeAndCoursepackage'
import classtypeAndTime from './modules/classtypeAndTime'
import locationAndCounts from './modules/locationAndCounts'

export default new Vuex.Store({
    modules: {
        user,
        permission,
        menu,
        member,
        student,
        event,
        record,
        course,
        coach,
        classhour,
        appointmenttype,
        coursetype,
        classtype,
        coursepackage,
        studentandclasstype,
        school,
        teachingpoint,
        show,
        locationAndClasstype,
        classtypeAndTime,
        locationAndCounts
    }
});